import { createSignal, onCleanup, onMount, type ParentComponent, Show } from "solid-js";
import { SplashScreenFallback } from "~/components/loading/SplashScreenFallback";
import { useWire } from "~/wire";

// Readiness can land in the same frame as mount, which paints the splash and
// tears it down before it reads as anything but a flicker.
const MIN_SPLASH_MS = 120;

// An auth handshake that never resolves — hung sync, dead network, error
// lifecycle — would otherwise pin the splash for the session.
const MAX_SPLASH_MS = 500;

export const ClientSideSplashScreen: ParentComponent = (props) => {
  const wire = useWire();
  const [mounted, setMounted] = createSignal(false);
  const [floorElapsed, setFloorElapsed] = createSignal(false);
  const [ceilingElapsed, setCeilingElapsed] = createSignal(false);

  onMount(() => {
    setMounted(true);
    const floor = setTimeout(() => setFloorElapsed(true), MIN_SPLASH_MS);
    const ceiling = setTimeout(() => setCeilingElapsed(true), MAX_SPLASH_MS);

    onCleanup(() => {
      clearTimeout(floor);
      clearTimeout(ceiling);
    });
  });

  // Authenticated surfaces render null until auth resolves, so lifting the
  // splash any earlier just uncovers empty panels.
  const showFallback = () => !ceilingElapsed() && (!floorElapsed() || !wire.auth.isReady());

  return (
    <>
      <Show when={mounted()}>{props.children}</Show>

      <Show when={showFallback()}>
        <SplashScreenFallback />
      </Show>
    </>
  );
};
